import { Box } from "@mui/material";
import { withTheme } from "@mui/styles";
import styled from "styled-components";

export const StyledAcknowledgeBlock = withTheme(styled(Box)`
    img {
        max-width: 120px;
    }
`);
